/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VipDiscountDto } from '../../models/vip-discount-dto';

export interface TriggerDefaultVipDiscount$Params {
  defaultVipDiscountId: string;
}

export function triggerDefaultVipDiscount(http: HttpClient, rootUrl: string, params: TriggerDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountDto>>> {
  const rb = new RequestBuilder(rootUrl, triggerDefaultVipDiscount.PATH, 'post');
  if (params) {
    rb.path('defaultVipDiscountId', params.defaultVipDiscountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VipDiscountDto>>;
    })
  );
}

triggerDefaultVipDiscount.PATH = '/discounts/vip/defaults/{defaultVipDiscountId}/trigger';
